import { DataStoreMockPlugin } from 'ui-common';

export class SiteStoreMockPlugin extends DataStoreMockPlugin {
  mocks: any;
  mockApis: string[] = [
    ...DataStoreMockPlugin.crudMockApis,
    'getSites',
    'getSite',
    'getSiteEnvironments'
  ];

  /**
   * @override
   */
  async getMockData() {
    this.mocks ??= await import('./site-store-mock-data');

    return this.mocks.data;
  }

  async getSites(id: string) {
    if (!this.mocks) {
      await this.getMockData();
    }
    if (id === '3f923335-f2e1-4ced-ad64-4000541732db') { // engineering
      return [this.mocks.mockCustomerSites[0], this.mocks.mockCustomerSites[1]];
    } else {
      return [this.mocks.mockCustomerSites[2], this.mocks.mockCustomerSites[3]];
    }
  }

  async getSite(id: string) {
    if (!this.mocks) {
      await this.getMockData();
    }
    return this.mocks.mockCustomerSites.find((site: any) => site.id === id);
  }

  async getEnvironments(_id: string, siteId: string) {
    if (!this.mocks) {
      await this.getMockData();
    }
    switch (siteId) {
      case 'site1':
        return this.mocks.mockSiteEnvironments.slice(0, 2);
      case 'site2':
        return this.mocks.mockSiteEnvironments.slice(2, 4);
      case 'site3':
        return this.mocks.mockSiteEnvironments.slice(4, 5);
      case 'site4':
        return this.mocks.mockSiteEnvironments.slice(5, 6);
      default:
        return [];
    }
  }

  async updateSiteEnvironmentSearchService(_customerId: string, _siteId: string, _siteEnvironmentId: string, searchService: any) {
    return searchService;
  }
}